import { globals, isBrowser, logger } from 'common-ui';
import { useInitCartStateWithAtgLegacyApi } from './useInitCartStateWithAtgLegacyApi';
import { useInitCartStateWithWebApi } from './useInitCartStateWithWebApi';

export const useInitCartState = () => {
  const initCartStateWithAtgLegacyApi = useInitCartStateWithAtgLegacyApi();
  const initCartStateWithWebApi = useInitCartStateWithWebApi();

  return async (): Promise<void> => {
    if (isBrowser()) {
      if (globals.useNewCartAPI) {
        return initCartStateWithWebApi();
      }
      return initCartStateWithAtgLegacyApi();
    }
    logger.log('useInitCartState skipping fetch as not in browser');
  };
};
